import { initFilterForm } from '../../assets/js/components/filter-form';

document.querySelectorAll('[data-resource-search-form]').forEach((form) => {
  const results = document.querySelector('[data-resource-library-results]');
  const status = form.querySelector('[data-resource-search-status]');
  const searchInput = form.querySelector('input[name="resource_search"]');
  const resetButton = form.querySelector('.section-resource-filters__reset');
  const ajaxUrl = form.dataset.ajaxUrl;
  const ajaxNonce = form.dataset.ajaxNonce;

  const filters = initFilterForm(form, {
    reset: resetButton,
    fields: 'select, input[name="resource_search"], input[name="resource_format"]',
  });

  if (!results || !ajaxUrl || !ajaxNonce || !window.fetch || !window.FormData) {
    filters.onSelect();
    return;
  }

  let requestController = null;
  let searchTimer = null;

  const updateAddressBar = (formData) => {
    const url = new URL(form.action, window.location.href);

    formData.forEach((value, key) => {
      if (String(value).trim()) {
        url.searchParams.set(key, value);
      }
    });

    window.history.replaceState({}, '', url);
  };

  const updateResults = async () => {
    requestController?.abort();
    const currentController = new AbortController();
    requestController = currentController;

    const formData = new FormData(form);
    formData.append('action', 'longyear_resource_search');
    formData.append('nonce', ajaxNonce);
    formData.append('posts_per_page', results.dataset.postsPerPage || '12');
    formData.append('empty_message', results.dataset.emptyMessage || '');

    form.classList.add('is-loading');
    results.setAttribute('aria-busy', 'true');

    if (status) {
      status.textContent = form.dataset.loadingLabel || '';
    }

    try {
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        signal: currentController.signal,
      });
      const payload = await response.json();

      if (!response.ok || !payload.success || !payload.data?.html) {
        throw new Error('Resource search failed.');
      }

      results.innerHTML = payload.data.html;
      updateAddressBar(new FormData(form));

      if (status) {
        const count = Number(payload.data.count) || 0;
        status.textContent = (form.dataset.resultsLabel || '').replace('{count}', String(count));
      }
    } catch (error) {
      if (error.name !== 'AbortError' && status) {
        status.textContent = form.dataset.errorLabel || '';
      }
    } finally {
      if (!currentController.signal.aborted) {
        form.classList.remove('is-loading');
        results.removeAttribute('aria-busy');
      }
    }
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    updateResults();
  });

  resetButton?.addEventListener('click', (event) => {
    event.preventDefault();
    window.clearTimeout(searchTimer);
    filters.clear();
    updateResults();
  });

  filters.onSelect(updateResults);

  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(updateResults, 300);
  });
});
